import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { useLanguage } from '../context/LanguageContext';
const IMGS = [IMAGES.cheesecake, IMAGES.box, IMAGES.cheesecake];
export function Instagram() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 lg:py-48 bg-texture-dark text-cream" data-id="element-132">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="grid lg:grid-cols-12 gap-10 items-end mb-20 lg:mb-28" data-id="element-134">
          <div className="lg:col-span-8" data-id="element-135">
            <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-136">
              <span className="w-10 h-px bg-caramel/40" data-id="element-137" />
              {t.instagram.eyebrow}
            </div>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-138">
              {t.instagram.title1}
              <br data-id="element-139" />
              <span className="italic font-extralight" data-id="element-140">
                {t.instagram.title2}
              </span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:text-right" data-id="element-141">
            <a href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" className="group inline-flex items-center gap-4 text-[11px] tracking-[0.3em] uppercase text-cream" data-id="element-142">
              <span className="relative pb-1" data-id="element-143">
                {t.instagram.cta}
                <span className="absolute bottom-0 left-0 right-0 h-px bg-cream group-hover:bg-caramel transition-colors duration-500" data-id="element-144" />
              </span>
              <span className="w-10 h-px bg-cream group-hover:bg-caramel group-hover:w-14 transition-all duration-500" data-id="element-145" />
            </a>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-10" data-id="element-146">
          {t.instagram.posts.map((label, i) => <motion.a key={i} href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.9,
          delay: i * 0.12
        }} className="group block" data-id="element-147">
              <div className="relative aspect-[4/5] overflow-hidden bg-espresso" data-id="element-148">
                <img src={IMGS[i]} alt={label} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.05]" data-id="element-149" />
              </div>
              <div className="mt-5 flex items-baseline justify-between text-[10px] tracking-[0.3em] uppercase" data-id="element-150">
                <span className="font-serif text-caramel" data-id="element-151">0{i + 1}</span>
                <span className="text-cream/50 group-hover:text-cream transition-colors duration-500" data-id="element-152">
                  {label}
                </span>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}